// eslint-disable-next-line import/prefer-default-export
export const INACTIVITY_DURATION = 60 * 600000
// export const INACTIVITY_DURATION = 30 * 60000
export const downloadTemplate = {
  batchLoanCreationCode: 2,
  batchCorporateCustomerAccountCode: 12,
  batchAccountCreationCode: 15,
  glCustomerUploadPostingCode: 16,
  batchDatingPostingCode: 18,
  batchIndividualCustomerCode: 19,
  assignedCardRequestCode: 22,
}

export const DUE_DILIGENCE_ENUMS = {
  LEGAL_AND_REGISTRATION_DOCUMENT: 'LegalAndRegistrationDocument',
  BOARD_AND_MANAGEMENT_INFORMATION: 'BoardAndManagementInformation',
  LEADERSHIP_AND_GOVERNANCE_STRUCTURE: 'LeadershipAndGovernanceStructure',
  FINANCIAL_STATEMENT: 'FinancialStatement',
  RECENT_FINANCIAL_PERFORMANCE: 'RecentFinancialPerformance',
  RISK_MANAGEMENT_FRAMEWORK: 'RiskManagementFramework',
  CREDIT_RISK_MANAGEMENT: 'CreditRiskManagement',
  LOAN_PORTFOLIO_DETAILS: 'LoanPortfolioDetails',
  AML_CFT_COMPLIANCE: 'AMLCFTCompliance',
  REGULATORY_COMPLIANCE: 'RegulatoryCompliance',
  REGULATORY_EXAMINATION_REPORTS: 'RegulatoryExaminationReports',
  RISK_AND_AUDIT_STRUCTURE: 'RiskAndAuditStructure',
  ONGOING_RISK_MONITORING: 'OngoingRiskMonitoring',
  INTERNAL_AUDIT_FINDINGS: 'InternalAuditFindings',
  CORPORATE_GOVERNANCE: 'CorporateGovernance',
  COLLATERAL_MANAGEMENT: 'CollateralManagement',
  CREDIT_BUREAU_AGREEMENT: 'CreditBureauAgreement',
  CUSTOMER_COMPLAINTS_HANDLING: 'CustomerComplaintsHandling',
  CUSTOMER_CREDIT_PROGRAMS: 'CustomerCreditPrograms',
  CONSUMER_LOAN_PRICING: 'ConsumerLoanPricing',
  EXTERNAL_BOARD_ASSESSMENT: 'ExternalBoardAssessment',
  IT_SYSTEM_AGREEMENTS: 'ITSystemAgreements',
  TAX_AND_DEDUCTION_REMITTANCES: 'TaxAndDeductionRemittances',
  ENVIRONMENTAL_AND_SOCIAL_RISK: 'EnvironmentalAndSocialRisk',
  ADVANCED_RISK_ANALYSIS: 'AdvancedRiskAnalysis',
  RATING_AGENCY_REPORT: 'RatingAgencyReport',
  INTERNAL_RISK_MONITORING: 'InternalRiskMonitoring',
}

export const DUE_DILIGENCE_UPLOAD_TYPES = {
  CAC_REGISTRATION: 'cacRegistration',
  OPERATING_LICENSE: 'operatingLicense',
  ARTICLE_OF_ASSOCIATION: 'articleOfAssociation',
  CV_UPLOAD: 'cvUpload',
  CBN_APPROVAL_EVIDENCE: 'cbnApprovalEvidence',
  BANK_ORGANISATION_STRUCTURE: 'bankOrganisationStructure',
  BANK_ORGANISATION_CHART: 'bankOrganisationChart',
  AUDITED_FINANCIAL_STATEMENT_1: 'auditedFinancialStatement1',
  AUDITED_FINANCIAL_STATEMENT_2: 'auditedFinancialStatement2',
  AUDITED_FINANCIAL_STATEMENT_3: 'auditedFinancialStatement3',
  LASTEST_FINANCIAL_PERFORMANCE: 'latestFinancialPerformance',
  RISK_MANAGEMENT_FRAMEWORK: 'riskManagementFrameworkUrl',
  RISK_MANAGEMENT_POLICIES: 'riskManagementPoliciesUrl',
  RISK_MANAGEMENT_LIMITS: 'riskManagementLimitsUrl',
  RISK_MANAGEMENT_MANUAL: 'riskManagementManualUrl',
  CREDIT_PORTFOLIO_REPORT: 'creditPortfolioReport',
  ANTI_MONEY_LAUNDRY: 'antiMoneyLaundryUrl',
  COUNTER_TERRORIST_FINANCING: 'CounterTerroristFinancingPoliciesUrl',
  REGULATORY_RETURNS_RENDITION: 'RegulatoryReturnsRenditionUrl',
  CBN_EXAMINATION_REPORTS: 'CBNExaminationReportsUrl',
  NDIC_EXAMINATION_REPORTS: 'NDICExaminationReportUrl',
  MANAGEMENT_RESPONSE_TO_EXAMINATION_REPORTS: 'ManagementResponseToExaminationReportUrl',
  MANAGEMENT_RESPONSE_TO_NDIC_EXAMINATION_REPORTS: 'ManagementResponseToNDICExaminationReportsUrl',
  DEPARTMENT_STRUCTURE_ORGANOGRAM: 'OrganogramUrl',
  RISK_MANAGEMENT_UNIT_STAFF_DETAILS: 'documentUrl',
  INTERNAL_AUDIT_FUNCTION_STAFF_DETAILS: 'documentUrl_2',
  RISK_MANAGEMENT_REPORTS_BOARD: 'RiskManagementReportsToBoardUrl',
  INTERNAL_AUDIT_REPORTS_LAST_YEAR: 'InternalAuditsReportUrlLastYear',
  INTERNAL_AUDIT_REPORTS_LAST_TWO_YEARS: 'InternalAuditsReportUrlTwoYearsAgo',
  INTERNAL_AUDIT_REPORTS_LAST_THREE_YEARS: 'InternalAuditsReportUrlThreeYearsAgo',
  CORPRATE_GOVERNANCE_REPORT: 'CorporateGovernanceUrl',
  COLLATERAL_VALUATION: 'CollateralValuationUrl',
  NATIONAL_COLLATERAL_REGISTER: 'NationalCollateralRegistryUrl',
  EVIDENCE_OF_AGREEMENT: 'evidenceOfAgreement',
  CUSTOMER_COMPLAINTS_MANAGEMENT: 'customerComplaintsManagement',
  COPIES_CONSUMER_CREDIT: 'copiesConsumerCredit',
  LOAN_PRICING_STRATEGY: 'loanPricingStrategy',
  CONSUMER_LOAN_PRICING: 'consumerLoanPricing',
  RECENT_EXTERNAL_BOARD: 'recentExternalBoard',
  SIGNED_AGREEMENT: 'signedAgreement',
  EVIDENCE_OF_TAX: 'evidenceOfTax',
}
